module.exports = __webpack_public_path__ + "img/natureza_e_sociedade.cb16b171.svg";